import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import router from './router.js'
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
//引用富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
 //引入富文本css
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//富文本编辑器添加实例
Vue.use(VueQuillEditor, /* { default global options } */)

VueAMap.initAMapApiLoader({
  key: 'ef7d3a5beceac439af2aa25b6d15dc08',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
// import login from './views/login/login.vue'
// import index from './views/home/index.vue'
import baseUrl from '../public/config.json'
Vue.prototype.$baseUrl = baseUrl.BASE_URL;
import api from "./service/api.js";
import api2 from "./service/api2.js";
//将封装的接口挂载到vue原型上
Vue.prototype.$api = api;
Vue.prototype.$api2 = api2;
import App from './App.vue'
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
